/* eslint-disable no-undef */
import {Toast as T} from 'mint-ui'
import {Indicator} from 'mint-ui'
import {MessageBox} from 'mint-ui'
export default class Toast {
  static show ({icon, title, duration, message = '',type = '',isHtml}) {
  /*  if (message && message.length >= 7) {
      icon = 'none';
    }*/
    if (icon === 'loading' || type === 'loading') {
      T({
        message: title||message,
        iconClass: 'mint-ui-toast-icon loading',
        duration: duration || 2000
      })
    } else if (icon === 'success' || type === 'success') {
      T({
        message: title||message,
        iconClass: 'mint-ui-toast-icon mint-ui-toast-icon-success',
        // iconClass: 'iconfont mint-ui-toast-icon-success',
        duration: duration || 2000
      })
    } else if (icon === 'warning' || icon === 'warn' || type === 'warning') {
      T({
        message: title||message,
        duration: duration || 2000,
        // iconClass: 'mint-ui-toast-icon mint-ui-toast-icon-warn'
        iconClass: 'iconfont mint-ui-toast-icon-warn'
      })
    } else if (icon === 'error' || type === 'error') {
      T({
        message: title||message,
        duration: duration || 2000,
        iconClass: 'iconfont mint-ui-toast-icon-error'
        // iconClass: 'mint-ui-toast-icon mint-ui-toast-icon-error'
      })
    } else {
      T({
        message: title || message ,
        duration: duration || 2000
      })
    }
  }

  static showLoading ({message}) {
    Indicator.open({
      text: message,
      spinnerType: 'snake'
    })
  }
  static hiddenLoading () {
    Indicator.close()
  }
}



// WEBPACK FOOTER //
// ./src/utils/toast.js